/** Name of the input fields. This is used to change the order of the input fields. */
export type GlobalFormInputName =
  | 'salutation'
  | 'empty'
  | 'firstName'
  | 'lastName'
  | 'email'
  | 'company'
  | 'country'
  | 'zipCode'
  | 'city'
  | 'streetAndNumber'
  | 'phoneNumber'
  | 'questions'
  | 'message';

export const DEFAULT_INPUT_ORDER: GlobalFormInputName[] = [
  'salutation',
  'empty',
  'firstName',
  'lastName',
  'email',
  'company',
  'country',
  'zipCode',
  'city',
  'streetAndNumber',
  'phoneNumber',
  'questions',
  'message',
];

export interface GlobalFormContactProps {
  title: string;
  data: Record<string, any>;
  url: string;
  fullWidth?: boolean;
  buttonText?: string;
  isOpen?: boolean;
  onClose?: () => void;
  topJsx?: any;
  additionalFormFields?: Record<string, string>;
  onlyShowZipcodeForGermany?: boolean;
  customValidator?: () => boolean;
  inputsOrder?: GlobalFormInputName[];
  confirmationTitleId?: string;
  confirmationMessageId?: string;
  streetAndNumberRequired?: boolean;
}
